export default __webpack_public_path__ + "static/media/link.c9be41f4.svg";